<template lang="pug">
  v-app
    v-content
      v-toolbar(color="primary", dark, extended, flat)
        v-spacer
        UserInfo(@show-info-dialog="showInfoModal")
      v-container
        v-layout(row justify-center)
          v-flex(xs12 lg10 xl7)
            v-card(class="card--flex-toolbar")
              template(v-if="isAdmin")
                v-toolbar(card prominent color="white" )
                  v-spacer
                  v-toolbar-items
                    v-btn(flat, to="/main/constructor") Конструктор
                    v-btn(flat, to="/main/employee") Сотрудники
                    v-btn(flat, to="/main/organisation") Организации
                  v-spacer
                v-divider
              router-view
      InfoPopup(:isVisibleModal="isShow", :id="modalId" @close-info-popup="closeInfoModal")
</template>

<script>
import UserInfo from '../../components/UserInfo/UserInfo'
import Preloader from '../../components/Common/Preloader/Preloader'
import InfoPopup from '../../components/DataBase/Common/InfoPopup'
export default {
  components: { InfoPopup, Preloader, UserInfo },
  name: 'Main',
  data: () => ({
    isShow: false,
    modalId: ''
  }),
  computed: {
    isAdmin() {
      return this.$store.state.userInfo.user.isAdmin
    }
  },
  methods: {
    showInfoModal() {
      this.modalId = 'main'
      this.isShow = true
    },
    closeInfoModal() {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  .v-card {
    background: #fff;
    margin-top: -50px !important;
    .v-toolbar {
      &__content {
        .v-toolbar__items {
          .v-btn--active:before,
          .v-btn:focus:before {
            background: transparent;
            border-bottom: 3px solid #007bff;
            border-radius: 0;
          }
          .v-btn:before {
            opacity: 1;
            border-radius: 0;
          }
          .v-btn:hover:before {
            opacity: 0.12;
            background: #007bff;
            border-radius: 0;
          }
        }
      }
    }
  }
  .theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Main/index.vue